import { makeStyles } from '@material-ui/core';
import green from '@material-ui/core/colors/green';

export const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 600,
  },
  listOfDocuments: {
    '& li': {
      paddingLeft: 0,
    },
  },
  iconDocument: {
    color: green[400],
    marginRight: 10,
  },
  paymentInfo: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    maxWidth: 600,
    marginTop: 20,
    '& :first-child': {
      maxWidth: 200,
      width: '100%',
      marginRight: 20,
    },
    '& p:nth-child(2)': {
      fontWeight: 'bold',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10,
    marginBottom: 20,
  },
}));
